module.exports = __webpack_public_path__ + "static/media/blog-38.93aa0a4f.webp";